import { useState } from 'react';
import Checkbox from 'epn-ui/umd/dist/components/CheckboxInput';
import Button from 'epn-ui/umd/dist/components/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons/faArrowLeft';
import useI18n from '@i18n';

import styles from './styles.module.scss';
import { SOCIAL_CATEGORY_ID } from '../../constants';
import { IConfirmPlacementProps } from '../../interfaces';

const ConfirmPlacement: React.FC<IConfirmPlacementProps> = ({
    formData,
    createInProgress,
    onSubmit,
    onBack,
}) => {
    const { t } = useI18n('Placements');
    const [checked, setChecked] = useState(false);

    const isSocialCategory: boolean = formData?.trafficSourceCategory === SOCIAL_CATEGORY_ID;

    const viewExample = (): void => {
        window.open(
            isSocialCategory ? '/wm/example-social.png' : '/wm/example-website.png',
            '_blank',
        );
    };

    return (
        <div className="mb-10">
            <div className="flex items-center xs:items-baseline">
                <button type="button" className={styles.arrow} onClick={onBack}>
                    <FontAwesomeIcon icon={faArrowLeft} />
                </button>
                <h4 className="font-medium text-blueGray-800 text-h2 text-[18px] xs:text-[24px] leading-[27px] xs:leading-[35px]">
                    {t('Confirmation of ownership of traffic source')}
                </h4>
            </div>
            <div className={styles.container}>
                <p className="mb-2 font-medium text-blueGray-800 text-[14px] xs:text-[16px]">
                    {t('Add the word')}
                    <span className="text-red-500"> ePN </span>
                    {isSocialCategory
                        ? t('to your traffic source description to confirm that you are the owner')
                        : t('to the footer of your site to confirm that you are the owner')}
                </p>
                <p className="mb-4 font-normal text-blueGray-600 text-[14px]">
                    {t('After successful verification, the verification word can be deleted')}
                </p>

                <Checkbox
                    id="confirmationPlacement"
                    label={
                        <span className="font-normal text-blueGray-500 text-[14px]">
                            {t('I added a verification word')}
                        </span>
                    }
                    checked={checked}
                    onChange={() => setChecked(!checked)}
                    className={styles.checkbox}
                />
            </div>
            <div className="flex flex-col sm:flex-row gap-4">
                <Button type="default" className="w-full md:w-auto" onClick={viewExample}>
                    {t('View example')}
                </Button>
                <Button
                    type="primary"
                    className="w-full md:w-auto"
                    disabled={!checked}
                    loading={createInProgress}
                    onClick={onSubmit}
                >
                    {t('Submit for review')}
                </Button>
            </div>
        </div>
    );
};

export default ConfirmPlacement;
